import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { useSelectedCompany } from '../use-selected-company.hook';
import { ShareCandidatePage, ShareCandidatesQuery } from './space.types';

export const useShareCandidates = (
  id: string | undefined,
  query: ShareCandidatesQuery = {},
  { enabled = true }: { enabled?: boolean } = {},
) => {
  const { selectedCompany } = useSelectedCompany();
  const companyId = selectedCompany?.id ?? '';

  const {
    data: { count = 0, records = [], totalPages = 0 } = {},
    isError,
    isFetched,
    isLoading,
  } = useAppQuery({
    enabled: enabled && Boolean(companyId && id),
    queryFn: () =>
      ApiService.get<ShareCandidatePage>(
        { endpoint: BackendRoute.DATA_ROOMS, routePath: [id ?? '', 'share-candidates'] },
        { queryParams: { ...query } },
      ),
    queryKey: [QueryKey.DATA_ROOM_SHARE_CANDIDATES, companyId, id, { ...query }],
  });

  return { count, isError, isFetched, isLoading, records, totalPages };
};
